export default Object.freeze({
  Domestic: ['1', '2', '3', '8', 'P'],
  International: ['4', '4A', '5']
})
